export default __webpack_public_path__ + "static/media/release4.deff8d5b.jpeg";